import './app/styles';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { CustomProvider } from 'rsuite';
import ru from 'rsuite/locales/ru_RU';
import en from 'rsuite/locales/en_US';

import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';

import { makeStore } from './app/store';

import App from './app/App';

export const store = makeStore();

const language = process.env.REACT_APP_LANG === 'en' ? 'en' : 'ru';
const rsuiteLocale = language === 'ru' ? ru : en;

if (language === 'ru') {
     
    const { messages } = require('./locales/ru/messages');
    i18n.load('ru', messages);
    i18n.activate('ru');
} else {
     
    const { messages } = require('./locales/en/messages');
    i18n.load('en', messages);
    i18n.activate('en');
}

document.documentElement.lang = language;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <React.StrictMode>
        <CustomProvider locale={rsuiteLocale}>
            <Provider store={store}>
                <Router future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
                    <I18nProvider i18n={i18n}>
                        <App />
                    </I18nProvider>
                </Router>
            </Provider>
        </CustomProvider>
    </React.StrictMode>,
);